<script>
import ManualAddress from '@/components/common/ManualAddress.vue'
import { VueAutosuggest } from 'vue-autosuggest'
import config from '@/config'
import axios from 'axios'
import _ from 'lodash'
import store from '@/store'

export default {
  name: 'AddressSearchSuperNew',
  components: {
    VueAutosuggest,
    ManualAddress
  },
  props: {
    orderPlace: {
      type: Object,
      required: true
    },
    client: {
      type: Object,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loadUserAddresses: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchResults: [],
      selectTitle: 'Adresa ...',
      setManual: false,
      manualModal: false
    }
  },
  created () {
    this.searchResults = []
    this.$store.state.userAddresses.addresses = []
    this.$eventBus.addEventListener('userAddressesLoaded', (response) => {
      this.searchResults = response.data.map((address) => {
        return {
          id: address.id,
          label: address.name,
          lat: address.lat,
          long: address.long,
          place_id: address.place_id,
          comment: address.comment,
          scara: address.scara,
          bloc: address.bloc,
          reper: address.reper
        }
      })
      this.$nextTick(() => {
        this.$refs.select.$el.querySelector('input').click()
        this.$refs.select.$el.querySelector('input').focus()
      })
    }, 'userAddressesLoaded')
  },
  mounted () {
    this.searchResults = this.$store.state.userAddresses.addresses.map((address) => {
      return {
        id: address.id,
        label: address.name,
        lat: address.lat,
        long: address.long,
        place_id: address.place_id,
        comment: address.comment,
        scara: address.scara,
        bloc: address.bloc,
        reper: address.reper,
        user_id: address.user_id
      }
    })
    if (this.orderPlace?.order_id && this.loadUserAddresses && this.client?.id) {
      this.getClientAddressesHistory()
    } else {
    }
  },
  computed: {
    uniqueSearchResults () {
      const results = {}
      this.searchResults.forEach((address) => {
        results[address.id] = address
      })
      return Object.entries(results).map((item) => {
        return item[1]
      })
    }
  },
  methods: {
    openManualModal () {
      this.manualModal = true
    },
    formatName (place) {
      const parts = [
        place.label
      ]
      if (place.bloc) {
        parts.push('BLOC: ' + place.bloc)
      }
      if (place.scara) {
        parts.push('SCARA: ' + place.scara)
      }
      if (place.reper) {
        parts.push('REPER: ' + place.reper)
      }

      return parts.join(' / ')
    },
    deleteItem (item) {
      if (confirm('Confirmă ștergerea acestei adrese')) {
        const deleteUrl = typeof item.isInternal !== 'undefined' ? (config.addrApiUrl + '/delete-place/' + item.id) : (config.userAddressesUrl + '/addresses/' + item.id)
        axios.delete(deleteUrl).then(
          () => {
            this.searchResults = this.searchResults.filter((i) => {
              return i.id !== item.id
            })
          }
        )
      }
    },
    onSearch (search) {
      if (search.length > 2) {
        this.search = search
        this.apiSearch(search, this)
      }
    },
    apiSearch: _.debounce((search, vm) => {
      vm.$axios.get(config.addrApiUrlNew + '/search', {
        params: {
          query: search,
          lat: store.getters['auth/companyLocation'].lat,
          lon: store.getters['auth/companyLocation'].lng,
          sessionToken: store.getters['dispatcherDashboard/getGoogleSessionToken']
        },
        headers: {
          'X-Auth-Token': 'ilM0DYqiHcV62P1G'
        }
      }).then((response) => {
        vm.searchResults = response.data.map((item) => {
          return {
            id: item.gPlaceId ? item.gPlaceId : (item.coordinates.lon + ',' + item.coordinates.lat),
            label: item.label,
            isInternal: typeof item.is_internal !== 'undefined',
            lat: item?.coordinates?.lat || undefined,
            lng: item?.coordinates?.lon || undefined,
            comment: item.comment ?? '',
            bloc: item.bloc ?? null,
            scara: item.scara ?? null,
            reper: item.reper ?? null,
            extra: item,
            gPlaceId: item.gPlaceId || undefined,
            ...item
          }
        })
      })
    }, 300),
    fetchPlaceDetails (item) {
      console.log('fetchPlaceDetails', item)
      this.$refs.select.$el.querySelector('input').blur()

      switch (item.type) {
        case 'google':
        case 'es-aproximate':
          // geocode
          this.$axios.get(`${config.addrApiUrlNew}/geocode`, {
            params: {
              query: item.label,
              lat: store.getters['auth/companyLocation'].lat,
              lon: store.getters['auth/companyLocation'].lng,
              sessionToken: store.getters['dispatcherDashboard/getGoogleSessionToken'],
              street: item.street || undefined,
              locality: item.locality || undefined,
              houseNumber: item.houseNumber || undefined,
              gPlaceId: item.gPlaceId || undefined
            },
            headers: {
              'X-Auth-Token': 'ilM0DYqiHcV62P1G'
            }
          }).then((response) => {
            this.$store.commit('dispatcherDashboard/renewGoogleSessionToken')
            this.placeChanged(response.data)
          })
          break
        case 'pelias':
        case 'es-exact':
        case 'internal':
          // direct usage
          this.placeChanged(item)
          break
        default:
          // user addresses
          this.placeChanged(item, true)
      }
    },
    placeChanged (place, legacy = false) {
      console.log('placeChanged', place, legacy)
      if (this.orderPlace.id) {
        this.$store.dispatch('dispatcherDashboard/updateOrderPlace', {
          orderPlace: {
            id: this.orderPlace.id,
            order_id: this.orderPlace.order_id,
            name: place.label,
            lat: legacy ? place.lat : place.coordinates.lat,
            long: legacy ? place.long : place.coordinates.lon,
            place_id: legacy ? `${place.long},${place.lat}` : `${place.coordinates.lon},${place.coordinates.lat}`,
            comment: place.comment || '',
            bloc: place.bloc || '',
            scara: place.scara || '',
            reper: place.reper || ''
          }
        })
          .then(() => {
            this.changePlaceInOrder(place, legacy)
            this.$toasted.success('Adresa actualizata')
          })
          .catch(() => {
            this.$toasted.error('Adresa invalida')
          })
          .then(() => {
            this.inUpdate = false
          })
      } else {
        this.changePlaceInOrder(place, legacy)
      }
    },
    changePlaceInOrder (place, legacy = false) {
      this.orderPlace.name = place.label
      this.orderPlace.lat = legacy ? place.lat : place.coordinates.lat
      this.orderPlace.long = legacy ? place.long : place.coordinates.lon
      this.orderPlace.place_id = legacy ? `${place.long},${place.lat}` : `${place.coordinates.lon},${place.coordinates.lat}`
      this.orderPlace.comment = place.comment || ''
      this.orderPlace.bloc = place.bloc || ''
      this.orderPlace.scara = place.scara || ''
      this.orderPlace.reper = place.reper || ''
    },
    getClientAddressesHistory () {
      this.$axios.get(config.userAddressesUrl + '/addresses/' + this.client.phone)
        .then((response) => {
          this.searchResults = response.data.map((address) => {
            return {
              id: address.id,
              label: address.name,
              lat: address.lat,
              long: address.long,
              place_id: address.place_id,
              comment: address.comment,
              scara: address.scara,
              bloc: address.bloc,
              reper: address.reper
            }
          })
          this.$refs.select.$el.querySelector('input').click()
          this.$refs.select.$el.querySelector('input').focus()
        })
    },
    addressSaved (address) {
      console.log('addressSaved', address)

      this.$axios.post(config.addrApiUrlNew + '/add', {
        ...address,
        sourceName: 'internal-ogo'
      }, {
        headers: {
          'X-Auth-Token': 'ilM0DYqiHcV62P1G'
        }
      })

      this.manualModal = false
      this.orderPlace.bloc = address.bloc
      this.orderPlace.comment = address.comment
      this.orderPlace.lat = address.lat
      this.orderPlace.long = address.lng
      this.orderPlace.name = address.name
      this.orderPlace.place_id = address.place_id
      this.orderPlace.reper = address.reper
      this.orderPlace.scara = address.scara
    }
  },
  watch: {
    searchResults: function (newVal, oldVal) {
      this.setManual = this.searchResults.length === 0
    },
    'orderPlace.order_id' () {
      this.$nextTick(() => {
        this.$refs.select.$el.querySelector('input').click()
        this.$refs.select.$el.querySelector('input').focus()
      })
      if (this.loadUserAddresses && this.client?.id) {
        this.getClientAddressesHistory()
      } else {
      }
    },
    'client.id': {
      handler (value, oldValue) {
        if (oldValue != null) {
          this.$nextTick(() => {
            this.$refs.select.$el.querySelector('input').click()
            this.$refs.select.$el.querySelector('input').focus()
          })
        }
      },
      deep: true
    }
  }
}
</script>

<template>
  <div class="order-address" >
    <vue-autosuggest
      ref="select"
      v-model="orderPlace.name"
      :disabled="disabled"
      :suggestions="[{ data: uniqueSearchResults }]"
      @selected="fetchPlaceDetails($event.item, orderPlace.name)"
      @input="onSearch"
      :key="'pvs-' + orderPlace.order_id"
      :get-suggestion-value="(s) => s.item.label"
      :input-props="{id:'autosuggest__input', disabled: disabled, style: 'width:100%;height: 38px;border: 1px solid #ccc;padding: 0 15px', placeholder:'Introduce-ți adresa (ex.: 13 Calea București)'}">
      <div slot-scope="{suggestion}" style="display: flex; align-items: center;">
        <div style="width:100%; display: flex; justify-content: space-between;">
          {{ formatName(suggestion.item) }}
          {{suggestion.item.comment ? ' - (' + suggestion.item.comment + ')' : null }}

          <b-button size="sm" variant="outline-danger" class="py-0 px-1" @mouseup.stop="deleteItem(suggestion.item)">
            <b-icon icon="x"></b-icon>
          </b-button>
        </div>
      </div>
    </vue-autosuggest>
    <div class="manual-address">
      <b-btn squared variant="white" size="sm" @click="openManualModal">
        <b-icon :icon="setManual === false ? 'plus-square' : 'plus-square-fill'" variant="success" ></b-icon>
      </b-btn>
    </div>
    <b-modal v-model="manualModal" size="xl" hide-header hide-footer class="pt-5">
      <br />
      <ManualAddress :address="orderPlace" @address-saved="addressSaved" />
    </b-modal>
  </div>
</template>

<style scoped>

</style>
